import { ErrorPage } from '@pages';
import { Loader } from '@components';
import { Stack } from '@mui/material';
import { useRequiredParams } from '@hooks';
import { useForm, useWatch } from 'react-hook-form';
import { useAppGetIntegration } from '@api';
import { IntegrationConfigLayout } from '../layout/IntegrationConfigLayout';
import { ConfigInfo } from '@Integrations/organisms/IntegrationConfigForm/ConfigInfo';
import { IntegrationConfigFormPayload } from '@Integrations/organisms/IntegrationConfigForm/Provider';
import { FormSectionActions } from '@Integrations/IntegrationConfigForm/components/FormSection/FormSectionActions';
import { DiscoveryFormSection } from '@Integrations/IntegrationConfigForm/organisms/FormSections/DiscoveryFormSection';
import { ConnectorFormSection } from '@Integrations/IntegrationConfigForm/organisms/FormSections/ConnectorFormSection';
import { IntegrationConfigFormSection } from '@Integrations/IntegrationConfigForm/organisms/FormSections/IntegrationConfigFormSection';

export function EditIntegrationForm() {
  const { id } = useRequiredParams(['id']);
  const { integration, integrationConfig: config, isIntegrationFetched } = useAppGetIntegration(id);
  const { handleSubmit, control } = useForm<IntegrationConfigFormPayload>({
    mode: 'onSubmit',
    defaultValues: {
      name: integration?.name || '',
      type: integration?.type || '',
      connected_resource_types: integration?.connected_resource_types || [],
      provisioner_id: integration?.provisioner_id || '',
      metadata: integration?.metadata || {},
    },
  });

  const { provisioner_id } = useWatch({ control });

  const onSubmit = () => {
    // here we will handle the form submit
  };

  if (!isIntegrationFetched) return <Loader />;

  if (!config) return <ErrorPage errorCode={404} errorMessage="Integration not found" />;

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <IntegrationConfigLayout
        sideInfo={<ConfigInfo info={config.info} links={config.links} connectorId={provisioner_id} />}
      >
        <Stack spacing={2}>
          <DiscoveryFormSection config={config} control={control} expanded />
          <ConnectorFormSection config={config} control={control} expanded isEdit />
          <IntegrationConfigFormSection config={config} control={control} expanded />
          <FormSectionActions onNextClick={() => {}} />
        </Stack>
      </IntegrationConfigLayout>
    </form>
  );
}
